module.exports = __webpack_public_path__ + "assets/img/lunch.b037b658.svg";